goog.provide("shadow.js.shim.module$react_bootstrap$Dropdown$default");
shadow.js.shim.module$react_bootstrap$Dropdown$default = shadow.js.require(141, {}).default;
